/**
 * Canonical in-app routes to a contact in the LIVE CRM.
 *
 * The CRM formerly labelled "experimental" (crm-v2) is now the live CRM, so
 * every notification surface — the bell, lead pop-ups, dashboard panels and
 * the outbound emails built in functions/src/utils/appLinks.ts — must land
 * there rather than on the legacy `/crm/contacts/{id}` screen.
 *
 * The legacy route still works, so links already sitting in people's inboxes
 * and any navigation INSIDE the old CRM keep functioning untouched.
 */

export const CRM_CONTACTS_PATH = '/crm-v2/contacts';

/** Tab names understood by ContactDetailPage (legacy aliases included). */
export type CrmContactTab = 'overview' | 'conversation' | 'activity' | 'files' | 'proposals';

export const crmContactPath = (contactId: string, tab?: CrmContactTab): string =>
  `/crm-v2/contact/${contactId}${tab ? `?tab=${tab}` : ''}`;

/**
 * Contact route when the id may be missing — falls back to the list.
 * Several callers pass an optional id; the old template-literal links
 * silently produced ".../undefined" in that case.
 */
export const crmContactPathOrList = (
  contactId?: string | null,
  tab?: CrmContactTab,
): string => (contactId ? crmContactPath(contactId, tab) : CRM_CONTACTS_PATH);
